import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding-bottom: 6.25rem;
  @media (max-height: 840px){
    padding-bottom: 0;
  }
`;

export const CenterContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export const Center = styled.main`
  display: flex;
  width: 100%;
  height: 100%;
  @media (max-width: 840px){
    flex-direction: column;
    justify-content: space-between;
  }
`;